<div data-test="avatar" class="flex shrink-0 items-center justify-center rounded-full cursor-[inherit]" [class]="roundClasses()">
  @if (displayIcon()) {
    <svg mib-icon name="user" [class]="iconClasses()" aria-hidden="true"></svg>
  } @else {
    {{ initials() }}
  }
</div>

@if (withName()) {
  <!-- The type the board gives a name beside a round: the branding ink, and 12/18 one step quieter. -->
  <div class="flex min-w-0 flex-col" [class.items-end]="nameFirst()">
    <span class="truncate text-sm font-medium text-mib-branding-900">{{ username() || 'Guest' }}</span>
    @if (description()) {
      <span class="truncate text-xs/4.5 text-gray-500">{{ description() }}</span>
    }
  </div>
}
